/* ArabEsq conversion layer: welcome popup + cart boosters (drawer + cart page) */
(function () {
  if (window.__arbConv) return;
  window.__arbConv = true;

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  ready(function () {
    /* ---- welcome popup ---- */
    var overlay = document.getElementById("arbOverlay");
    if (overlay) {
      var seen = false;
      try { seen = localStorage.getItem("arb_welcome_seen") === "1"; } catch (e) {}
      var markSeen = function () { try { localStorage.setItem("arb_welcome_seen", "1"); } catch (e) {} };
      var close = function () { overlay.classList.remove("show"); markSeen(); };
      overlay.querySelectorAll("[data-arb-pop-close]").forEach(function (b) { b.addEventListener("click", close); });
      overlay.addEventListener("click", function (e) { if (e.target === overlay) close(); });
      if (document.getElementById("arbPopSuccessFlag")) {
        overlay.classList.add("show");
        markSeen();
      } else if (!seen) {
        setTimeout(function () { overlay.classList.add("show"); }, 6000);
      }
    }

    /* ---- cart boosters ---- */
    var UPSELL_VARIANT = "51936375963929";
    var UPSELL_IMG = "https://cdn.shopify.com/s/files/1/0829/7588/3545/files/classic-dad-hat-spruce-front-698034ea1ed6c.jpg?v=1773019366&width=120";

    function upsellHTML() {
      return '<img src="' + UPSELL_IMG + '" alt="Baladi dad hat"><div class="um"><b>Complete the fit</b>Baladi dad hat · $35</div><button type="button" data-arb-add="' + UPSELL_VARIANT + '">Add</button>';
    }
    function cartHasHat(scope) {
      var hasHat = false;
      scope.querySelectorAll(".cart-item__name").forEach(function (n) {
        var t = (n.textContent || "").toLowerCase();
        if (t.indexOf("hat") > -1 || t.indexOf("cap") > -1) hasHat = true;
      });
      return hasHat;
    }

    function enhanceDrawer() {
      var drawer = document.querySelector("cart-drawer");
      if (!drawer) return;
      var inner = drawer.querySelector(".drawer__inner");
      if (!inner) return;
      var header = inner.querySelector(".drawer__header");
      if (header && !inner.querySelector(".arb-shipnote")) {
        var note = document.createElement("div");
        note.className = "arb-shipnote";
        note.innerHTML = "<b>Free US shipping over $75.</b> Made to order · 5–7 day craft time.";
        header.insertAdjacentElement("afterend", note);
      }
      var footer = inner.querySelector(".drawer__footer");
      var isEmpty = drawer.classList.contains("is-empty");
      var existing = inner.querySelector(".arb-upsell");
      if (footer && !isEmpty && !cartHasHat(inner) && !existing) {
        var up = document.createElement("div");
        up.className = "arb-upsell";
        up.innerHTML = upsellHTML();
        footer.insertAdjacentElement("beforebegin", up);
      } else if (existing && (isEmpty || cartHasHat(inner))) {
        existing.remove();
      }
    }

    function enhanceCartPage() {
      var footer = document.querySelector(".cart__footer");
      if (!footer) return;
      if (!document.querySelector(".cart__footer .arb-shipnote")) {
        var note = document.createElement("div");
        note.className = "arb-shipnote";
        note.innerHTML = "<b>Free US shipping over $75.</b> Made to order · 5–7 day craft time.";
        footer.insertAdjacentElement("afterbegin", note);
      }
      var main = document.querySelector("#main-cart-items, cart-items");
      if (main && !cartHasHat(document) && !document.querySelector(".cart__footer .arb-upsell")) {
        var up = document.createElement("div");
        up.className = "arb-upsell";
        up.innerHTML = upsellHTML();
        var ctas = footer.querySelector(".cart__ctas");
        if (ctas) ctas.insertAdjacentElement("beforebegin", up);
        else footer.appendChild(up);
      }
    }

    enhanceDrawer();
    enhanceCartPage();
    var drawerEl = document.querySelector("cart-drawer");
    if (drawerEl) {
      var mo = new MutationObserver(function () {
        clearTimeout(window.__arbDrawerT);
        window.__arbDrawerT = setTimeout(enhanceDrawer, 120);
      });
      mo.observe(drawerEl, { childList: true, subtree: true });
    }
  });
})();
